<div class="d-block d-md-inline">
  {{ "Condition" | translate }}:
  <span class="condition {{ lineItem.condition ? (lineItem.condition.toLowerCase() | slugify) : '' }}">
    {{ equipmentItemService.humanizeCondition(lineItem.condition) }}
  </span>
  &middot;
  <span class="year-of-purchase d-block d-md-inline">
    {{ "Year of purchase" }}: <strong>{{ lineItem.yearOfPurchase || ("Unspecified" | translate) }}</strong>
  </span>
</div>
